<div id="actions-left" class="actions-left"></div>
<div id="actions-right" class="actions-right"></div>
